import { Detail } from "./Detail";
import { Create } from "./Create";
import { RequestList } from "./RequestList";

export default { Detail, Create, RequestList };
